<script lang="ts">
  import { _ } from 'svelte-i18n';
  import TechnologyFilter from '$lib/components/TechnologyFilter.svelte';
  import { scheduleCount } from '$lib/stores/guided';

  /**
   * Which technologies the company must be using, and which mail gaps it has.
   *
   * The same control the filter panel draws, in its `embedded` variant — one
   * component, because what a selection *means* is the hard part here and two
   * copies would explain it differently within a month. The panel and the
   * wizard would then disagree about what the customer had just asked for.
   *
   * What `embedded` buys is room: the sidebar shows each mail gap's caveat as a
   * `title`, which is weak, and here there is space to print it. That matters
   * more for these than for any other step, because these are the only filters
   * in the product that select on something being *absent* — "no DKIM" means
   * "no key at the selectors we tried", and a customer who reads it as "no
   * DKIM" will say so to a prospect.
   *
   * The running total re-asks on every tick, through the component's onChange
   * rather than a watcher here — which is the convention StepLegalForm set, and
   * the better one: a watcher fires on mount too and would count a selection
   * nobody had made.
   *
   * It matters more on this step than on any other. Wix is 22,592 domains and
   * Quentn is 35, and nothing on the control says which is which, so the count
   * is the only thing that tells a customer they have just narrowed to nothing.
   *
   * The shape is the one StepChannels and StepFounding use — the control, then
   * a line saying what happens if it is left alone. Without that line an
   * optional step reads as a required one, and this is the most skippable step
   * in the sequence.
   */
</script>

<div class="space-y-4">
  <TechnologyFilter embedded={true} onChange={scheduleCount} />

  <p class="text-xs text-gray-500">{$_('guided.technology.hint')}</p>
</div>
